import { RootStore } from 'store/reducer';
import { useSelector } from 'react-redux';
import { selectResourceTypesList } from 'store/v1/resource_types/resource_types.selectors';
import { apiClient } from 'v4/core/apiClient';
import { myReduxProxy } from 'v5/api/_common/reduxProxy.connected';
import { myMessageService } from 'v5/services/internal/MessageService/MessageService.connected';
import { createGroupsService } from './GroupsService.impl';

export const myGroupsService = createGroupsService({
  client: apiClient,
  reduxProxy: myReduxProxy,
  services: { messageService: myMessageService },
  useGroupsSnapshot: () => useSelector((state: RootStore) => state.groups),
  useResourceTypes: () => useSelector(selectResourceTypesList)
});
